module.exports = __webpack_public_path__ + "static/media/VestasSans-Headline.914d024e.eot";